// @flow
import './modal.css';

import React from 'react';

import { Text } from '@sonyged/proc-ui';

import { ArrowIcon, LossColor } from '../../../common/components/ArrowIcon';
import AppContext from '../../../javascripts/AppContext';
import image1 from '../../../assets/images/pages/sushi/sushi_field_grade_1@3x.png';
import image2 from '../../../assets/images/pages/sushi/sushi_field_grade_2@3x.png';
import image3 from '../../../assets/images/pages/sushi/sushi_field_grade_3@3x.png';

const advancedGradeImg = function(customerCount: number, score: number): string {
  if (customerCount === 1) {
    if (score < 0) return image3;
    else if (score < 300) return image2;
    else return image1;
  } else if (customerCount === 2) {
    if (score < 0) return image3;
    else if (score < 600) return image2;
    else return image1;
  } else {
    if (score < 0) return image3;
    else if (score < 1000) return image2;
    else return image1;
  }
};

const gradeImg = function(customerCount: number, score: number): string {
  if (customerCount === 1) {
    if (score < 200) return image3;
    else if (score < 400) return image2;
    else return image1;
  } else if (customerCount === 2) {
    if (score < 400) return image3;
    else if (score < 700) return image2;
    else return image1;
  } else {
    if (score < 500) return image3;
    else if (score < 1000) return image2;
    else return image1;
  }
};

type Props = {
  moreKanji?: boolean,
  finish: boolean,
  score: number,
  half: 'first' | 'second',
  customerCount: number,
};

const FinishModal = ({ customerCount, finish, score, half, moreKanji = false }: Props) => {
  let context = React.useContext(AppContext);
  React.useEffect(() => {
    if (!context || !finish) return;
    context.soundController.sePlay('kansei');
  }, [context, finish]);

  if (!finish) {
    return <span />;
  }

  let image = moreKanji ? advancedGradeImg(customerCount, score) : gradeImg(customerCount, score);
  let txt = moreKanji ? (score < 0 ? 'そんしたお金' : 'もうけたお金') : 'もらったお金';

  return (
    <div className={'finish-view-container proc-border-radius center-aligned secondary20-border-color'}>
      <div className={'background absolute white-bg-color'} />
      <div className={'contents'}>
        {half === 'first' && (
          <>
            <div className={'desc proc-large-font gray100-color'} style={{ marginBottom: 10 }}>
              前半おわり！
            </div>
            <div className={'desc proc-large-font gray100-color'}>後半もがんばろうね。</div>
          </>
        )}
        {half === 'second' && (
          <>
            <div className={'title proc-small-font secondary100-color'}>{txt}</div>
            <div className={'desc proc-huge-font gray100-color'}>
              <Text color={score < 0 ? LossColor : null}>{Math.abs(score)}</Text>
              <Text color={score < 0 ? LossColor : null} className="postfix">
                {' 円 '}
              </Text>
              <span className="postfix">{moreKanji && <ArrowIcon forNum={score} className="postfix" />}</span>
            </div>
            <img className={'image'} src={image} />
          </>
        )}
      </div>
    </div>
  );
};

export default FinishModal;
